import React from 'react';

interface WhaleIconProps {
  className?: string;
}

const WhaleIcon: React.FC<WhaleIconProps> = ({ className }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9056_107858)">
        <path
          d="M0.430298 6.00441C0.430298 8.98935 2.8501 11.4091 5.83508 11.4091C6.84444 11.4091 7.78914 11.1325 8.59752 10.6509C9.14298 11.2102 9.98286 11.3319 10.6399 10.9722L9.66102 9.82197C10.6366 8.84421 11.2399 7.49475 11.2399 6.00441C11.2399 3.01942 8.82006 0.599609 5.83508 0.599609C3.89652 0.599609 3.13269 1.27521 3.13269 1.9508H5.83508C6.95442 1.9508 7.86186 2.85823 7.86186 3.9776C7.86186 5.09696 6.95442 6.00441 5.83508 6.00441H0.430298Z"
          fill="#715BF8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.83509 3.9776V0.599609C5.06415 0.759293 4.48389 1.45481 4.48389 2.2886C4.48389 3.1224 5.06415 3.81792 5.83509 3.9776Z"
          fill="#715BF8"
        />
        <path
          d="M2.23984 7.79961C1.90847 7.79961 1.63984 7.53098 1.63984 7.19961C1.63984 6.86824 1.90847 6.59961 2.23984 6.59961C2.57121 6.59961 2.83984 6.86824 2.83984 7.19961C2.83984 7.53098 2.57121 7.79961 2.23984 7.79961Z"
          fill="#111111"
        />
      </g>
      <defs>
        <clipPath id="clip0_9056_107858">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WhaleIcon;